<template>
    <el-select v-model="selectedCompany" :placeholder="placeholder" @change="handleChange">
        <el-option v-if="isSearchModel" label="すべて" :value="ALL"/>
        <el-option v-for="item in companies" :key="item.company_code" :label="`${item.company_name} - ${item.department_name}`"
            :value="item.company_code" />
    </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import axios from 'axios';
import { CompanyInfo } from '@/components/models/companyinfo';
import { ALL } from '@/config/constants';

export default defineComponent({
    name: 'CompanySelector',
    props: {
        isSearch: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: String,
            default: ALL,
        },
        placeholder: {
            type: String,
            default: '契約会社名を選択してください',
        },
    },
    
    emits: ['update:modelValue', 'change'],

    setup(props, { emit }) {
        const companies = ref<CompanyInfo[]>([]);
        const selectedCompany = ref(props.modelValue);
        const isSearchModel = ref(props.isSearch);

        onMounted(() => {
            fetchCompanies();
        });

        watch(() => props.modelValue, (newValue) => {
            selectedCompany.value = newValue
        });


        const handleChange = (value: string) => {
            emit('update:modelValue', value);
            emit('change', value);
        };

        
        const fetchCompanies = async () => {
            try {
                const response = await axios.get('/api/companies');
                companies.value = response.data.data;
                // 确保在获取数据后更新选中值
                if (props.modelValue && !selectedCompany.value) {
                    selectedCompany.value = props.modelValue
                }
            } catch (error) {
                // console.error('会社情報取得失敗:', error);
            }
        };



        return {
            companies,
            selectedCompany,
            handleChange,
            ALL,
            isSearchModel,
        };
    },
});
</script>